<template>
	<div>
		<!-- vista con la tabla de los envios masivos -->
		<CRow v-if="showConsult" class="justify-content-center">
			<CCol sm="12">
				<CCard>
					<CCardHeader style="background: #97ca3d; color: black;">
						<h3>
							Envíos Masivos en Proceso
						</h3>
					</CCardHeader>
					<CCardBody>
						<!-- filtro de la tabla -->
						<CRow>
							<CCol sm="4">
								<CInput
									v-model="filter"
									placeholder="Búscar"
									label="Filtrar"
								></CInput>
							</CCol>
							<CCol sm="4">
								<div role="group" class="form-group">
									<label for="urb"
										>Registros por Página</label
									>
									<multiselect
										v-model="perPage"
										:options="recordsPergPage"
										:searchable="false"
										:close-on-select="true"
										:show-labels="false"
										placeholder="Seleccione"
									>
									</multiselect>
								</div>
							</CCol>
						</CRow>
						<CRow>
							<CCol>
								<span class="float-left">
									<b-badge variant="info">Nota:</b-badge> Las
									solicitudes sombreadas en color
									<b>verde</b> es por que ya fueron asignadas.
									Si deseas reasignar una solicitud puedes ir
									al menú
									<b>Asignados</b>
								</span>
							</CCol>
						</CRow>
						<!-- tabla de los envios -->
						<CRow>
							<CCol sm="12">
								<p style="margin-bottom: 30px;">
									<span class="float-right"
										>Cantidad de Envíos:
										<CBadge shape="pill" color="info">
											{{ totalRows }}</CBadge
										>
									</span>
								</p>
								<b-table
									:fixed="true"
									v-if="showTable"
									@filtered="onFiltered"
									:filter="filter"
									stacked="lg"
									striped
									outlined
									hover
									bordered
									:current-page="currentPage"
									:per-page="perPage"
									:items="tableConsult"
									:fields="fieldsTableConsult"
								>
									<!-- width para la columna acciones -->
									<template #table-colgroup="scope">
										<col
											v-for="field in scope.fields"
											:key="field.key"
											:style="{
												width:
													field.key === 'actions'
														? '100px'
														: '',
											}"
										/>
									</template>
									<!-- botones de la seccion acciones -->
									<template #cell(actions)="row">
										<b-button
											title="Asignar"
											:disabled="
												row.item.sended &&
												row.item.requestRecieve > 0
													? false
													: true
											"
											@click="showViewAssing(row.item)"
											pill
											variant="primary"
											size="sm"
											class="mr-1"
										>
											<i class="fas fa-user-tie"></i>
										</b-button>
										<b-button
											v-if="
												row.item.idstatus !==
													closedCampaign &&
													row.item.idstatus !==
														deletedCampaign
											"
											@click="modalCloseRequest(row.item)"
											title="Cerrar Campaña"
											pill
											variant="danger"
											size="sm"
											class="mr-1"
										>
											<i class="fas fa-times-circle"></i>
										</b-button>
									</template>
								</b-table>
							</CCol>
						</CRow>
						<!-- paginacion de la tabla -->
						<CRow>
							<CCol sm="12">
								<b-pagination
									v-model="currentPage"
									:total-rows="totalRows"
									:per-page="perPage"
									align="right"
									first-number
									last-number
									pills
								>
									<template #prev-text
										><span class="text-primary"
											>Anterior</span
										></template
									>
									<template #next-text
										><span class="text-success"
											>Siguiente</span
										></template
									>
									<template #page="{ page, active }">
										<b v-if="active">{{ page }}</b>
										<i v-else>{{ page }}</i>
									</template>
								</b-pagination>
							</CCol>
						</CRow>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>
		<AssigmentRequest
			v-if="showAssing"
			:id-request="idRequestForAsign"
			:requests-assigned="requestsAssigned"
			:requests-update="requestsUpdate"
			:total-requests-assigned="requestsAssigned"
		/>
		<!-- modal para confirmar que desea cerrar un envío masivo -->
		<CModal
			:show.sync="modalConfirmClose"
			:close-on-backdrop="false"
			:centered="true"
			title="Cerrar envío"
			size="lg"
			color="danger"
			style="text-align:justify;"
		>
			<CRow class="content-left">
				<CCol sm="12">
					<p>Estas intentado cerrar el siguiente envío masivo:</p>
				</CCol>
			</CRow>
			<CRow class="content-center">
				<CCol sm="10">
					<b-table
						class="text-left"
						stacked
						striped
						outlined
						hover
						bordered
						:items="requestForClose"
						:fields="fieldsRequestForClose"
					>
					</b-table>
				</CCol>
			</CRow>
			<CRow>
				<CCol>
					<span>
						<p>
							Si cierras el envío las empresas que no hayan
							enviado una solicitud para actualizar sus datos
							perderán el acceso al mismo y no podrán realizar la
							solicitud hasta que se realiace otra campaña masiva
							o individual.
						</p>
					</span>
				</CCol>
			</CRow>
			<CRow>
				<CCol sm="12">
					<span>
						<p>
							Si deseas realmente cerrar el envío por favor
							escribe <b>Cerrar</b> y luego haz clic en el botón
							<b>Cerrar envío</b>
						</p>
					</span>
				</CCol>
			</CRow>
			<CRow>
				<CCol sm="4">
					<CInput v-model="confirmClose"></CInput>
				</CCol>
			</CRow>
			<template #header>
				<h6 class="modal-title">Cerrar Envío</h6>
				<CButtonClose
					@click="modalConfirmClose = false"
					class="text-white"
				/>
			</template>
			<template #footer>
				<b-button
					v-if="confirmClose === 'Cerrar'"
					@click="closeRequest(requestForClose[0].idRequest)"
					pill
					variant="warning"
					size="lg"
					class="mr-1"
				>
					Cerrar el envío
				</b-button>
				<b-button
					@click="modalConfirmClose = false"
					pill
					variant="primary"
					size="lg"
					class="mr-1"
					>No cerrar el envío
				</b-button>
			</template>
		</CModal>
		<!-- modal para confirmar el cierre de una campaña -->
		<CModal
			:show.sync="modalSuccessClose"
			:close-on-backdrop="false"
			:centered="true"
			title="Se cerro la campaña!!"
			size="sm"
			color="success"
			style="text-align:justify;"
		>
			<CRow>
				<CCol>
					<p>Se cerro exitosamente la campaña</p>
				</CCol>
			</CRow>
			<template #header>
				<h6 class="modal-title">Se cerro la campaña!!</h6>
				<CButtonClose
					@click="modalSuccessClose = false"
					class="text-white"
				/>
			</template>
			<template #footer>
				<b-button
					@click="modalSuccessClose = false"
					pill
					variant="success"
					size="lg"
					class="mr-1"
					>Cerrar
				</b-button>
			</template>
		</CModal>
	</div>
</template>
<script>
	import inProcessRequests from '../../functions/functionsInProcessRequests';
	import AssigmentRequest from '../../components/assigmentRequests';
	export default {
		/**Componente del modulo de envío masivos usado para consultar los envíos en proceso
		 * y asignar las solicitudes recibidas a otros usuarios del ssistama */
		name: 'consultRequests',
		title: 'Envíos Masivos en Proceso | Infoguia',
		components: {
			AssigmentRequest,
		},
		data() {
			return {
				//tabla de los envios en proceso
				showConsult: true,
				fieldsTableConsult: [
					{
						key: 'categories',
						label: 'Categoría',
					},
					{
						key: 'locations',
						label: 'Localidades',
					},
					{
						key: 'createdDate',
						label: 'Fecha de Creación',
					},
					{
						key: 'sendedDate',
						label: 'Fecha de Envío',
					},
					{
						key: 'status',
						label: 'Estatus',
					},
					{
						key: 'quantitySends',
						label: 'Cantidad de Envíos',
					},
					{
						key: 'emailsOpen',
						label: 'E-Mails Abiertos',
					},
					{
						key: 'requestRecieve',
						label: 'Solicitudes Recibidas',
					},
					{
						key: 'requestAssigned',
						label: 'Solicitudes Asignadas',
					},
					{
						key: 'actions',
						label: 'Acciones',
					},
				],
				tableConsult: [],
				//datos de la paginacion
				currentPage: 1,
				totalRows: 0,
				perPage: 10,
				filter: '',
				recordsPergPage: [5, 10, 15, 20],
				showTable: false,
				//datos para cerrar una campaña
				confirmClose: '',
				modalConfirmClose: false,
				//tabla con los datos de la campaña a cerrar
				requestForClose: [],
				fieldsRequestForClose: [
					{
						key: 'typeRequest',
						label: 'Tipo de envío',
					},
					{
						key: 'categorieRequest',
						label: 'Categoría',
					},
					{
						key: 'createdDate',
						label: 'Fecha de Creación',
					},
					{
						key: 'sendedDate',
						label: 'Fecha de envío',
					},
					{
						key: 'quantitySends',
						label: 'Cantidad de envíos',
					},
					{
						key: 'emailsOpen',
						label: 'E-Mails abiertos',
					},
					{
						key: 'requestRecieve',
						label: 'Solicitudes recibidas',
					},
				],
				//datos para modal de confirmacion al cerrar un envio
				modalSuccessClose: false,
				//datos para las asignaciones
				showAssing: false,
				idRequestForAsign: 0,
				deletedCampaign: 11,
				closedCampaign: 14,
				requestsAssigned: 0,
				requestsUpdate: 0,
			};
		},
		created() {
			this.loadData();
		},
		methods: {
			onFiltered(filteredItems) {
				// Metodo para actualizar el numero de paginas en el paginado a medida que se filtra
				this.totalRows = filteredItems.length;
				this.currentPage = 1;
			},
			modalCloseRequest(rowToClose) {
				// Metodo para mostrar la modal de confirmacion antes de eliminar
				this.confirmClose = '';
				this.requestForClose = [
					{
						typeRequest: this.typeMasiveSend(
							rowToClose.codLocation
						),
						categorieRequest: rowToClose.categories,
						createdDate: rowToClose.createdDate,
						sendedDate: rowToClose.sendedDate,
						quantitySends: rowToClose.quantitySends,
						emailsOpen: rowToClose.emailsOpen,
						requestRecieve: rowToClose.requestRecieve,
						idRequest: rowToClose.idRequest,
					},
				];
				this.modalConfirmClose = true;
			},
			typeMasiveSend: function(codType) {
				// Este metodo regresa el nombre del tipo de envio segun el codigo
				let nameType = '';
				switch (codType) {
					case 'A':
						nameType = 'Envío Nacional';
						break;
					case 'S':
						nameType = 'Envío por Estados';
						break;
					case 'C':
						nameType = 'Envío por Ciudades';
						break;
					case 'U':
						nameType = 'Envío por Urbanización';
						break;
				}
				return nameType;
			},
			closeRequest(idRequest) {
				let loader = this.$loading.show();
				inProcessRequests
					.closeRequest(idRequest)
					.then((response) => {
						this.tableConsult.splice(
							this.tableConsult.findIndex(
								(item) => item.idRequest === idRequest
							),
							1
						);
						this.modalSuccessClose = true;
						this.modalConfirmClose = false;
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						loader.hide();
					});
			},
			showViewAssing(item) {
				this.showConsult = false;
				this.showAssing = true;
				this.idRequestForAsign = item.idRequest;
				this.requestsAssigned = item.requestAssigned;
				this.requestsUpdate = item.requestRecieve;
			},
			loadData() {
				let loader = this.$loading.show();
				inProcessRequests
					.getMasiveRequestsInProcess()
					.then((response) => {
						this.totalRows = response.length;
						for (let index = 0; index < response.length; index++) {
							this.tableConsult[index] = {
								categories:
									response[index].categoria.nombrecategoria,
								locations: 'Nacional',
								createdDate: response[index].created_at,
								sendedDate:
									response[index].sendingDate == null
										? 'Por ser Enviado'
										: response[index].sendingDate,
								quantitySends: response[index].quantity,
								emailsOpen: response[index].requestsVisualized,
								requestRecieve: response[index].requestsUpdate,
								sended:
									response[index].sendingDate == null
										? false
										: true,
								codLocation: response[index].locationSent,
								idRequest: response[index].idRequests,
								idstatus: response[index].idstatus,
								_rowVariant:
									response[index].requestsAssigned > 0
										? 'success'
										: '',
								status: response[index].status.name,
								requestAssigned:
									response[index].requestsAssigned,
							};
							if (response[index].locationSent == 'S') {
								let statesStrin = '';
								this.tableConsult[index].locations = response[
									index
								].estados[0].nombreestado.trim();
								if (response[index].estados.length > 1) {
									for (
										let indexStates = 0;
										indexStates <
										response[index].estados.length;
										indexStates++
									) {
										statesStrin +=
											response[index].estados[indexStates]
												.nombreestado + ', ';
										this.tableConsult[
											index
										].locations = statesStrin
											.trim()
											.slice(0, -1);
									}
								}
							} else if (response[index].locationSent == 'C') {
								let citiesString = '';
								this.tableConsult[index].locations = response[
									index
								].ciudades[0].nombreciudad.trim();
								if (response[index].ciudades.length > 1) {
									for (
										let indexCities = 0;
										indexCities <
										response[index].ciudades.length;
										indexCities++
									) {
										citiesString +=
											response[index].ciudades[
												indexCities
											].nombreciudad + ', ';
										this.tableConsult[
											index
										].locations = citiesString
											.trim()
											.slice(0, -1);
									}
								}
							} else if (response[index].locationSent == 'U') {
								let urbString = '';
								this.tableConsult[index].locations = response[
									index
								].urbanizations[0].nameUrbanization.trim();
								if (response[index].urbanizations.length > 1) {
									for (
										let indexUrb = 0;
										indexUrb <
										response[index].urbanizations.length;
										indexUrb++
									) {
										urbString +=
											response[index].urbanizations[
												indexUrb
											].nameUrbanization + ', ';
										this.tableConsult[
											index
										].locations = urbString
											.trim()
											.slice(0, -1);
									}
								}
							}
						}
						if (this.tableConsult.length > 0) {
							this.showTable = true;
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						loader.hide();
					});
			},
		},
	};
</script>
